<div class="drop-preview">
  @if (layoutToggleVisible() || showModeToggles()) {
    <div class="drop-preview-top-left-toggles" [class.narrow]="narrow()">
      @if (layoutToggleVisible()) {
        <div class="tooltip-buttons">
          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              [class.active]="labelLayoutStyle() === 'stacked'"
              (click)="dropPreviewService.toggleLabelLayout()">
              @if (labelLayoutStyle() === 'stacked') {
                <span class="icon icon-layout-stacks" aria-hidden="true"></span>
              } @else {
                <span class="icon icon-layout-grid" aria-hidden="true"></span>
              }
            </button>
            <ng-template #tooltip>
              Switch to {{ labelLayoutStyle() === 'stacked' ? 'grid' : 'stacked' }} layout
            </ng-template>
          </app-tooltip-wrapper>
        </div>
      }

      @if (showModeToggles()) {
        <div class="tooltip-buttons">
          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              [class.active]="dropTiersModeActive()"
              (click)="selectDropTiersMode()">
              <span class="icon icon-list-numbered" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>Show Drop Tiers</ng-template>
          </app-tooltip-wrapper>

          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn random-loot-regenerate-btn"
              [class.active]="randomLootModeActive()"
              [class.regenerating]="randomLootGenerating()"
              [disabled]="randomLootRegenerateDisabled()"
              (click)="selectRandomLootMode()">
              <span class="icon icon-loop2" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>{{ randomLootTooltip() }}</ng-template>
          </app-tooltip-wrapper>

          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              [class.active]="libraryModeActive()"
              (click)="selectLibraryMode()">
              <span class="icon icon-drawer2" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>Show Item Library</ng-template>
          </app-tooltip-wrapper>

          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              (click)="openItemDesigner()">
              <span class="icon icon-drawer-plus" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>Open Item Designer</ng-template>
          </app-tooltip-wrapper>
        </div>
      }
    </div>
  }

  <app-rule-preview class="drop-preview-container"
    [rules]="rules()"
    [ruleGroups]="ruleGroups()"
    [resizable]="resizable()"
    [scrollable]="scrollable()"
    [compact]="compact()"
    [largeBackground]="largeBackground()"
    [layoutStyle]="labelLayoutStyle()"
    [forceGlow]="dropPreviewService.forceGlow()"
    [forceVisible]="holdAlt()"
    [disableBeams]="!dropPreviewService.beams()"
    (itemLibraryClick)="dropPreviewService.onItemLibraryClick($event.event, $event.rule)">
  </app-rule-preview>

  @if (showBeamsToggle() || (showGlowToggle() && poe2) || showAreaLevelInput()) {
    <div class="drop-preview-bottom-left-toggles" [class.narrow]="narrow()">
      @if (showBeamsToggle()) {
        <div class="tooltip-buttons">
          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              [class.active]="dropPreviewService.beams()"
              (click)="dropPreviewService.toggleBeams()">
              <span class="icon icon-beam" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>Toggle beams</ng-template>
          </app-tooltip-wrapper>
        </div>
      }

      @if (showGlowToggle() && poe2) {
        <div class="tooltip-buttons">
          <app-tooltip-wrapper class="btn-tooltip">
            <button type="button" class="btn"
              [class.active]="!glowToggleOff()"
              (click)="dropPreviewService.toggleForceGlow()">
              <span class="icon icon-label-glow" aria-hidden="true"></span>
            </button>
            <ng-template #tooltip>Toggle proximity label glow</ng-template>
          </app-tooltip-wrapper>
        </div>
      }

      @if (showAreaLevelInput()) {
        <div class="tooltip-buttons">
          <app-tooltip-wrapper class="btn-tooltip">
            <input type="number" class="area-level-input form-control minmax"
              min="1" [max]="areaLevelMax" inputmode="numeric" placeholder="Area"
              [(ngModel)]="areaLevelInput"
              (change)="onAreaLevelInputChange()">
            <ng-template #tooltip>Area level</ng-template>
          </app-tooltip-wrapper>
        </div>
      }
    </div>
  }

  @if (showHoldAltToggle()) {
    <div class="drop-preview-hold-alt-toggle" title="Simulate holding Alt to show all hidden items">
      <button type="button" class="hold-alt-key"
        [class.off]="!holdAlt()"
        (click)="toggleHoldAlt()">Hold Alt</button>
    </div>
  }

  @if (showBackgroundToggle()) {
    <div class="drop-preview-bottom-right-toggles" [class.narrow]="narrow()">
      <div class="tooltip-buttons">
        @for (bg of backgroundOptions; track bg.id) {
          <app-tooltip-wrapper [right]="true" class="btn-tooltip"
            [class.bg-active]="dropPreviewService.labelPreviewBg() === bg.id">
            <button type="button" class="btn bg-btn"
              [class.active]="dropPreviewService.labelPreviewBg() === bg.id"
              [style.background-image]="bg.thumbStyle"
              (click)="dropPreviewService.setLabelPreviewBg(bg.id)">
            </button>
            <ng-template #tooltip>{{ bg.name }}</ng-template>
          </app-tooltip-wrapper>
        }
      </div>
    </div>
  }
</div>

@if (itemDesignerOpen()) {
  <app-item-designer-dialog
    [initialItem]="itemDesignerCloneItem()"
    (close)="closeItemDesigner()">
  </app-item-designer-dialog>
}
